import React from 'react';

import { StyledFilterSelectReset } from './FilterSelect.styles';
import { FilterOption } from '../../FilterSelect';

type Props = {
  selectedFilterCount: number;
  setSelectedFilters: (selectedFilters: FilterOption[]) => void;
};

export const FilterSelectReset = ({ selectedFilterCount, setSelectedFilters }: Props) => {
  return (
    <StyledFilterSelectReset>
      <span
        className="reset"
        onClick={() => {
          setSelectedFilters([]);
        }}
      >
        Reset
      </span>
      <span> {selectedFilterCount} Selected </span>
    </StyledFilterSelectReset>
  );
};
